import { MatomoTrackingConfig } from '@arianee/arn-types';
import { ArnPageViewEvent } from '../ArnPageViewEvent';
import { ArnTrackedEvent } from '../ArnTrackedEvent';

export interface MatomoTrackEvent {
  event: string;

  [key: string]: string;
}

export class MatomoTrackingService {
  constructor(config: MatomoTrackingConfig) {
    const code = `
      <!-- Matomo Tag Manager -->
      var _mtm = window._mtm = window._mtm || [];
      _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.async=true; g.src='https://cdn.matomo.cloud/arianee.matomo.cloud/container_${config.trackingCode}.js'; s.parentNode.insertBefore(g,s);
      <!-- End Matomo Tag Manager -->
      `;
    const script = document.createElement('script');
    script.innerHTML = code;
    script.id = 'matomo';
    document.head.append(script);
  }

  protected getMatomo(): object[] {
    return (window as any)._mtm || [];
  }

  report(event: ArnTrackedEvent): void {
    this.getMatomo().push(event);
  }

  pageViewed(pageViewEvent?: ArnPageViewEvent): void {
    const matomo = this.getMatomo();
    if (pageViewEvent?.title) {
      matomo.push(['setDocumentTitle', pageViewEvent.title]);
    }
    if (pageViewEvent?.location) {
      matomo.push(['setCustomUrl', pageViewEvent.location]);
    }
    matomo.push(['trackPageView']);
  }

  /**
   * Trigger a "cta-clicked" event with the CTA name.
   *
   * @see https://developer.matomo.org/guides/tagmanager/datalayer
   * @param ctaEvent
   */
  ctaClicked(ctaEvent: MatomoTrackEvent): void {
    this.getMatomo().push({ ...ctaEvent });
  }
}
